<template>
  <v-container fluid class="fill-height">
    <v-toolbar-title>Proxy API </v-toolbar-title>
    <v-row justify="space-around">
      <v-col cols="5">
        <div>
          <p class="font-weight-regular">
            Request Body
          </p>
        </div>
        <ace-editor :content="requestData" :on-change="onRequestChange" />
        <v-layout align-end justify-end>
          <v-btn
            small
            class="white--text"
            color="grey"
            depressed
            @click="onSubmit"
            style="margin-top: 5px"
            >SEND</v-btn
          >

          <user-request-form
            :editor-request="requestData"
            :selected-request="selectedUserRequest"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="white--text"
                  color="grey"
                  depressed
                  style="margin-left: 5px; margin-top: 5px"
                  >SAVE</v-btn
                >
              </template>
              <span>Save {{ selectedUserRequest.title }}</span>
            </v-tooltip>
          </user-request-form>
        </v-layout>
      </v-col>

      <v-col cols="5">
        <div class="d-flex justify-space-between">
          <p class="font-weight-regular">
            Response Body
          </p>
          <v-spacer></v-spacer>
          <span v-show="status">
            <v-icon v-show="status" right>
              mdi-set-none
            </v-icon>
            Status:
          </span>
          <span
            v-show="status"
            v-bind:class="{
              'green--text text--lighten-1 ml-2': status === '200',
              'red--text text--lighten-1 ml-2': status !== '200'
            }"
          >
            {{ status }}
          </span>
        </div>
        <ace-editor :content="responseData" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="userRequestsData"
          :hide-default-header="false"
          @click:row="handleRowClick"
          no-data-text="No Saved Request"
        >
          <template v-slot:item.pearlData.updateDatetime="{ item }">
            <span>{{
              new Date(item.pearlData.updateDatetime).toLocaleString()
            }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <proxy-api-request-confirm-delete
              :request="item"
              class="float-left"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Delete {{ item.title }}</span>
              </v-tooltip>
            </proxy-api-request-confirm-delete>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-snackbar v-model="showError" :timeout="timeout" color="red">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showError = false">
          Close
        </v-btn>
      </template>
      <p v-for="(error, index) of errors" :key="index">
        {{ error }}
      </p>
    </v-snackbar>
    <v-overlay z-index="10000" :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import AceEditor from '@/components/AceEditor';
import { createNamespacedHelpers } from 'vuex';
import UserRequestForm from '@/views/ProxyApi/UserRequestForm';
import ProxyApiRequestConfirmDelete from '@/views/ProxyApi/ConfirmDeleteRequest';
const { mapState, mapActions } = createNamespacedHelpers('proxyApi');

export default {
  name: 'ProxyApi',
  components: { UserRequestForm, AceEditor, ProxyApiRequestConfirmDelete },
  async created() {
    await this.getUserRequests();
  },
  methods: {
    ...mapActions([
      'postRequestForWorkerApis',
      'getUserRequests',
      'setSelectedUserRequest'
    ]),
    async onSubmit() {
      await this.postRequestForWorkerApis(JSON.parse(this.requestData));
    },
    handleRowClick: function(item) {
      this.requestData = JSON.stringify(item.request);
      this.setSelectedUserRequest(item);
    },
    onRequestChange: function(val) {
      this.requestData = JSON.stringify(JSON.parse(val), null, 4);
    }
  },
  computed: {
    ...mapState([
      'selectedUserRequest',
      'responseData',
      'status',
      'userRequestsData',
      'loading',
      'errors'
    ])
  },
  watch: {
    errors(newValue) {
      this.showError = newValue.length > 0;
    }
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Title',
          value: 'title',
          sortable: true
        },
        {
          text: 'Last Update',
          value: 'pearlData.updateDatetime',
          sortable: true
        },
        {
          text: 'Action',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ],
      requestData: JSON.stringify(
        {
          header: {
            componentTrigram: 'wca',
            division: 'fsh',
            env: 'dev'
          },
          payload: {
            method: 'GET',
            path: '/health/topics'
          }
        },
        undefined,
        4
      )
    };
  }
};
</script>
<style scoped>
html {
  overflow: hidden !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>
